import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginResponseData } from '../models/responses/login-response-data';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { NewContractRequest } from '../models/requests/new-contract-request';
import { ContractDto } from '../models/contractDto';
import { ContractVm } from '../models/requests/ConractVm';
import { approveContractVm } from '../models/approveContractVm';
import { UpdateContract } from '../models/requests/update-contract';
import { EmpNumberChangeRequestDto } from '../models/EmpNumberChangeRequestDto';
import { ContractRenewalRequestDto } from '../models/ContractRenewalRequestDto';
import { DateRangeRequest } from '../models/requests/DateRangeRequest';
import { ContractPendingApprovalDto } from '../models/ContractPendingApprovalDto';
import { approveContractAxiom } from '../models/approveContractAxiom';
import { adhocDto } from '../models/adhocDto';
@Injectable({
  providedIn: 'root'
})
export class ContractsService {
  

  constructor(private httpClient: HttpClient) { }
  getContracts(): Observable<ApiResponseObject<ContractDto[]>> {
     ; 
    var result = this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts`);
    return result;
  }
  
  saveContract(newContractRequest: ContractVm): Observable<ApiResponseObject<ContractDto>> {
   
    return this.httpClient.post<ApiResponseObject<ContractDto>>(`${environment.apiUrl}/Contracts`, newContractRequest);
  }

  updateContract(updateContractRequest: UpdateContract): Observable<ApiResponseObject<ContractDto>> {
   
    return this.httpClient.put<ApiResponseObject<ContractDto>>(`${environment.apiUrl}/Contracts`, updateContractRequest);
  }

  updatePONumber(updateRequest: ContractDto): Observable<ApiResponseObject<ContractDto>> {
   
    return this.httpClient.put<ApiResponseObject<ContractDto>>(`${environment.apiUrl}/Contracts/UpdatePO`, updateRequest);
  }

  requestExpressApproval(expressApproval: any): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Contracts/RequestExpressApproval`, expressApproval);
  }

  getPendingContracts(): Observable<ApiResponseObject<ContractDto[]>> {
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/MyPendingContract`);
  }
  getAxioms(): Observable<ApiResponseObject<any[]>> {
    return this.httpClient.get<ApiResponseObject<any[]>>(`${environment.apiUrl}/Axiom`);
  }

  getPendingExpressApproval(): Observable<ApiResponseObject<ContractDto[]>> {
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/GetMyExpressRequestforApproval`);
  }

  approveContract(approveContractRequest: approveContractAxiom): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Contracts/Approve`, approveContractRequest);
  }

  getPendingRequestApprovals(id:number): Observable<ApiResponseObject<ContractPendingApprovalDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<ContractPendingApprovalDto[]>>(`${environment.apiUrl}/Contracts/GetPendingApproval/${id}`);
  }
  approveExpressApproval(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Contracts/ApproveExpressApproval`, approveContractRequest);
  }

  rejectExpressApproval(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Contracts/RejectEpressApprovalRequest`, approveContractRequest);
  }

  rejectContract(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Contracts/Reject`, approveContractRequest);
  }

  getActiveContracts(): Observable<ApiResponseObject<ContractDto[]>> {
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/GetByStatus?contractStatus=Approved`);
  }
  
  getAllPendingContracts(): Observable<ApiResponseObject<ContractDto[]>> {
   
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/GetByStatus?contractStatus=Pending`);
  }

  getExpiringContracts(): Observable<ApiResponseObject<ContractDto[]>> {
   
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/GetExpiringThisMonth`);
  }

  getContractsByUser(): Observable<ApiResponseObject<ContractDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/GetContractsForCurrentUser`);
  }
  
  getAllContracts(): Observable<ApiResponseObject<ContractDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/`);
  }
  
  // getContractsValidforEmpcreation(): Observable<ApiResponseObject<ContractDto[]>> {
  //   return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/GetValidContractsforEmpCreation`);
  // }
  getContractsValidforEmpcreation(): Observable<ApiResponseObject<ContractDto[]>> {
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/EmployeeUploads/GetValidContractsforEmpCreation`);
  } 
  
  GetValidContractsforEpressApprovalCreation(): Observable<ApiResponseObject<ContractDto[]>> {
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/GetValidContractsforEpressApprovalCreation`);
  }

  
  ChangeNoOfEmployees(updateRequest: any): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.put<ApiResponseObject<boolean>>(`${environment.apiUrl}/Contracts/ChangeNoOfEmployees`, updateRequest);
  }

  getById(id: number): Observable<ApiResponseObject<ContractDto>> {
    return this.httpClient.get<ApiResponseObject<ContractDto>>(`${environment.apiUrl}/Contracts/${id}`);
  }
  GetByFunction(id: number): Observable<ApiResponseObject<ContractDto[]>> {
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/GetByFunction/${id}`);
  }
  GetByCreator(email: string): Observable<ApiResponseObject<ContractDto[]>> {
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/GetByCreator/${email}`);
  }
  GetByStatus(email: string): Observable<ApiResponseObject<ContractDto[]>> {
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/GetByStatus/${email}`);
  }

  terminateRequest(data: any): Observable<ApiResponseObject<ContractDto>> {

    return this.httpClient.post<ApiResponseObject<ContractDto>>(`${environment.apiUrl}/Contracts/CloseRequest`, data);
  }

  GetPendingEmpChangeRequest(): Observable<ApiResponseObject<EmpNumberChangeRequestDto[]>> {
    return this.httpClient.get<ApiResponseObject<EmpNumberChangeRequestDto[]>>(`${environment.apiUrl}/Contracts/GetPendingEmpChangeRequest`);
  }
  
  approveEmpChange(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Contracts/ApproveEmpChange`, approveContractRequest);
  }
  rejectEmpChange(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Contracts/RejectEmpChange`, approveContractRequest);
  }

  RenewContract(renewdata: any): Observable<ApiResponseObject<ContractDto>> {
   
    return this.httpClient.post<ApiResponseObject<ContractDto>>(`${environment.apiUrl}/Contracts/RenewContract`, renewdata);
  }

  getMyPendingRenewalToApprove(): Observable<ApiResponseObject<ContractRenewalRequestDto[]>> {
    return this.httpClient.get<ApiResponseObject<ContractRenewalRequestDto[]>>(`${environment.apiUrl}/Contracts/GetMyPendingRenewalToApprove`);
  }
  approveRenewal(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Contracts/ApproveRenewal`, approveContractRequest);
  }

  rejectRenewal(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Contracts/RejectRenewal`, approveContractRequest);
  }

 

  getByDateRange(dateRangeRequest: DateRangeRequest): Observable<ApiResponseObject<ContractDto[]>> {
   
    return this.httpClient.post<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/getByDateRange`, dateRangeRequest);
  }
  CancelRequest(data: any): Observable<ApiResponseObject<ContractDto>> {

    return this.httpClient.post<ApiResponseObject<ContractDto>>(`${environment.apiUrl}/Contracts/CancelRequest`, data);
  }

  
  MyApprovedLabourRequests(): Observable<ApiResponseObject<ContractDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<ContractDto[]>>(`${environment.apiUrl}/Contracts/MyApprovedLabourRequests`);
  }


}
